<template>
  <div class="ds-page">
    <div class="mb-3" style="font-size: 12px">
      <a class="text-dark mr-3" style="cursor: pointer" @click="back">‹ Back</a>
        <span style="color: #D1D1D1; margin-right: 16px; font-weight: bold">|</span>
      <span style="color: #9F9F9F;">Data Submission › </span><b style="color: #2D2D2D;">Reminder Settings</b>
    </div>
    <p style="max-width: 1050px">
      Reminders are sent automatically on the schedule below, once per monthly period. Label Maker and Oil Maker each have their own settings. Sales Managers can still send  <br> manually from their page.
    </p>
    <div class="ds-tabs">
      <button class="ds-tab" :class="{ active: tab === 'oil' }" @click="tab = 'oil'">Oil Maker</button>
      <button class="ds-tab" disabled>Label Maker </button>
      <!-- <span class="ds-soon">Coming Soon</span> -->
    </div>

    <div v-if="loading" class="ds-card ds-muted text-center">Loading...</div>
    <div v-else-if="!s" class="ds-card ds-muted text-center">{{ tabName }} reminder settings are not available yet.</div>

    <template v-else>
      <div class="ds-card p-0">
        <!-- Active -->
        <div class="row-s">
          <div class="col-l"><b>{{ tabName }} Reminder</b><span class="ds-sub">These settings apply to {{ tabName }} only</span></div>
          <div class="col-r">
            <label class="switch mb-0"><input type="checkbox" v-model="s.active" /><span class="slider"></span></label>
            <span :class="s.active ? 'text-primary' : 'ds-muted'" class="ml-2">{{ s.active ? "Active" : "Inactive" }}</span>
            <!-- <span v-if="meta.updatedBy" class="ds-sub mt-2">Last updated by {{ meta.updatedBy }} · {{ meta.updatedAt }}</span> -->
          </div>
        </div>

        <!-- Saat Inactive: field lain redup tapi tetap bisa diubah -->
        <div :class="{ dim: !s.active }">
          <!-- Schedule -->
          <div class="row-s">
            <div class="col-l"><b>Automatic send schedule</b>
              <span class="ds-sub">Reminders are sent automatically every month for the previous month's period</span></div>
            <div class="col-r">
              <div class="d-flex align-items-center" style="gap: 12px">
                Send on day
                <select class="fig-select fig-select-sm" v-model="s.day">
                  <option v-for="d in dayOptions" :key="d" :value="d">{{ d }}</option>
                </select>
                of the following month, at
                <select class="fig-select fig-select-md" v-model="s.hour">
                  <option v-for="h in hourOptions" :key="h" :value="h">{{ hourLabel(h) }}</option>
                </select>
                WIB
              </div>

              <div class="fig-note mt-3">
                Example: data for <b class="note-dark">{{ example.range }}</b> is checked automatically.
                {{ tabName }}s that meet the condition below will receive a reminder on
                <b class="note-hl">{{ s.day }} {{ example.next }} · {{ hourLabel(s.hour) }} WIB</b>.
              </div>
            </div>
          </div>

          <!-- Condition -->
          <div class="row-s">
            <div class="col-l"><b>Condition</b></div>
            <div class="col-r">
              <div class="d-flex align-items-center" style="gap: 10px">
                Data Discrepancy Tolerance
                <select class="fig-select fig-select-sm" v-model="s.tolerance"><option v-for="t in options.tolerance" :key="t" :value="t">{{ t }}%</option></select>
              </div>
              <div class="fig-hints">
                Example: If 10,000 Oil QR codes are expected to be reported, the SFTP data must contain at least
                {{ (10000 * (100 - s.tolerance) / 100).toLocaleString("en-US") }} QR codes for the reminder emails to stop being sent.
              </div>
            </div>
          </div>

          <!-- Channel -->
          <div class="row-s">
            <div class="col-l"><b>Default channel</b></div>
            <div class="col-r">
              <label class="mb-0"><input type="checkbox" v-model="s.email" /> Email</label>
              <div v-if="errors.channel" class="ds-hint text-danger">{{ errors.channel }}</div>
            </div>
          </div>

          <!-- Template -->
          <div class="row-s">
            <div class="col-l"><b>Message template</b>
              <span class="ds-sub" style="font-size: 12px;">Variables: {{ variablesText }}</span></div>
            <div class="col-r">
              <label class="ds-label">Subject (email)</label>
              <input class="ds-input" :class="{ 'is-error': errors.subject }" v-model="s.subject" :maxlength="options.subjectMax" />
              <div class="ds-hint d-flex justify-content-between">
                <span class="text-danger">{{ errors.subject }}</span>
                <span>{{ s.subject.length }} / {{ options.subjectMax }}</span>
              </div>
              <label class="ds-label">Message (email)</label>
              <textarea class="ds-input" :class="{ 'is-error': errors.message }" rows="5" v-model="s.message" :maxlength="options.messageMax"></textarea>
              <div class="ds-hint d-flex justify-content-between">
                <span class="text-danger">{{ errors.message }}</span>
                <!-- <span>{{ s.message.length }} / {{ options.messageMax }}</span> -->
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-end" style="gap: 8px">
        <button class="ds-btn ds-btn-danger-o" :disabled="saving" @click="back">Cancel</button>
        <button class="ds-btn ds-btn-primary" :disabled="saving || !isDirty || hasError" @click="save">{{ saving ? "Saving..." : "Save" }}</button>
      </div>
    </template>
  </div>
</template>

<script>
const MONTHS = ["January","February","March","April","May","June","July","August","September","October","November","December"];
const ENDPOINTS = {
  oil: "/api/data-submission/oil-maker/reminder-settings",
  label: null,
};

export default {
  name: "ReminderSettings",
  data() {
    return {
      tab: "oil",
      loading: false,
      saving: false,
      s: null,
      original: "",
      meta: { updatedBy: "", updatedAt: "" },
      options: {
        dayMin: 1, dayMax: 28, hourMin: 0, hourMax: 23,
        tolerance: [1, 2, 3, 4, 5], variables: [], subjectMax: 150, messageMax: 2000,
      },
    };
  },
  computed: {
    endpoint() { return ENDPOINTS[this.tab]; },
    tabName() { return this.tab === "oil" ? "Oil Maker" : "Label Maker"; },
    dayOptions() {
      const { dayMin, dayMax } = this.options;
      return Array.from({ length: dayMax - dayMin + 1 }, (_, i) => dayMin + i);
    },
    hourOptions() {
      const { hourMin, hourMax } = this.options;
      return Array.from({ length: hourMax - hourMin + 1 }, (_, i) => hourMin + i);
    },
    variablesText() { return this.options.variables.map((v) => `{${v}}`).join(" "); },
    example() {
      const now = new Date();
      const prev = new Date(now.getFullYear(), now.getMonth() - 1, 1);
      const last = new Date(now.getFullYear(), now.getMonth(), 0).getDate();
      return { range: `1–${last} ${MONTHS[prev.getMonth()]}`, next: MONTHS[now.getMonth()] };
    },
    errors() {
      if (!this.s) return {};
      return {
        subject: this.s.subject.trim() ? "" : "Required",
        message: this.s.message.trim() ? "" : "Required",
        channel: this.s.active && !this.s.email ? "Select at least one channel." : "",
      };
    },
    hasError() { return Object.values(this.errors).some(Boolean); },
    isDirty() { return !!this.s && JSON.stringify(this.s) !== this.original; },
  },
  watch: {
    tab() { this.fetchSettings(); },
  },
  mounted() { this.fetchSettings(); },
  beforeRouteLeave(to, from, next) {
    if (!this.isDirty || this.saving || !this.$swal) return next();
    this.$swal.fire({
      title: "Discard changes?",
      text: "You have unsaved changes. Leave this page without saving?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Discard",
      cancelButtonText: "Keep editing",
    }).then((r) => next(r.isConfirmed));
  },
  methods: {
    hourLabel(h) { return String(h).padStart(2, "0") + ":00"; },
    back() { this.$router.push({ name: "DataSubmissionOilMaker" }); },

    // ---------- API ----------
    async fetchSettings() {
      this.s = null;
      if (!this.endpoint) return;
      this.loading = true;
      try {
        const res = await this.$http.get(this.endpoint);
        const d = res.data.data;
        const o = d.options || {};
        this.options = {
          dayMin: o.send_day ? o.send_day.min : 1,
          dayMax: o.send_day ? o.send_day.max : 28,
          hourMin: o.send_hour ? o.send_hour.min : 0,
          hourMax: o.send_hour ? o.send_hour.max : 23,
          tolerance: o.tolerance || [1, 2, 3, 4, 5],
          variables: o.variables || [],
          subjectMax: o.subject_max || 150,
          messageMax: o.message_max || 2000,
        };
        this.meta = { updatedBy: d.updated_by, updatedAt: d.updated_at ? d.updated_at.slice(0, 16) : "" };
        this.s = {
          active: !!d.is_active,
          day: d.send_day,
          hour: d.send_hour,
          tolerance: d.tolerance,
          email: !!d.channel_email,
          subject: d.subject || "",
          message: d.message || "",
        };
        this.original = JSON.stringify(this.s);
      } catch (err) {
        this.notify("error", "Failed to load settings", err);
      } finally {
        this.loading = false;
      }
    },
    async save() {
      if (this.hasError) return;
      const payload = {
        is_active: this.s.active,
        send_day: this.s.day,
        send_hour: this.s.hour,
        tolerance: this.s.tolerance,
        channel_email: this.s.email,
        subject: this.s.subject,
        message: this.s.message,
      };
      this.saving = true;
      try {
        await this.$http.put(this.endpoint, payload); // ganti ke patch kalau backend pakai PATCH
        await this.fetchSettings();
        this.notify("success", `${this.tabName} reminder settings saved`);
      } catch (err) {
        this.notify("error", "Failed to save", err);
      } finally {
        this.saving = false;
      }
    },
    notify(icon, title, err) {
      if (!this.$swal) return;
      const body = err && err.response && err.response.data;
      let text = body && body.message;
      if (body && body.data && typeof body.data === "object") {
        const lines = Object.values(body.data).filter((v) => typeof v === "string");
        if (lines.length) text = lines.join("\n");
      }
      this.$swal.fire({ title, text, icon, timer: icon === "success" ? 1200 : undefined, showConfirmButton: icon !== "success" });
    },
  },
};
</script>

<style src="./ds-common.css"></style>
<style scoped>
.row-s { display: flex; padding: 20px 24px; border-bottom: 1px solid #eef1f4; }
.row-s:last-child { border-bottom: 0; }
.dim { opacity: .5; }
.col-l { width: 240px; flex-shrink: 0; padding-right: 16px; color: #2D2D2D; font-size: 13px; font-weight: 600; }
.col-r { flex: 1; }

.ds-tab:disabled { cursor: not-allowed; color: #C4CBCD; }
.ds-soon { margin-left: 6px; padding: 1px 6px; border-radius: 8px; background: #EDF1F2; font-size: 10px; color: #9aa4ad; }
.ds-input.is-error { border-color: #F92A2A; }

.switch { position: relative; display: inline-block; width: 36px; height: 20px; }
.switch input { opacity: 0; width: 0; height: 0; }
.slider { position: absolute; inset: 0; background: #ccd2d8; border-radius: 20px; cursor: pointer; transition: .2s; }
.slider:before { content: ""; position: absolute; height: 14px; width: 14px; left: 3px; top: 3px; background: #fff; border-radius: 50%; transition: .2s; }
.switch input:checked + .slider { background: #3b7ddd; }
.switch input:checked + .slider:before { transform: translateX(16px); }

.fig-select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  height: 36px;
  padding: 0 32px 0 14px;
  background-color: #fff;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='8' viewBox='0 0 10 8'%3E%3Cpath d='M0 0h10L5 8z' fill='%23222'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 14px center;
  border: 1px solid #d9dee3;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 700;
  color: #222;
  cursor: pointer;
}
.fig-select:focus { outline: none; border-color: #1f4aa0; }
.fig-select-sm { width: 68px; }
.fig-select-md { width: 94px; }

.fig-note {
  display: block;
  border: 0;
  background: #f1f3f2;
  border-radius: 6px;
  padding: 12px 16px;
  font-size: 12px;
  line-height: 1.6;
  color: #6b6f72;
}
.note-dark { color: #222; font-weight: 700; }
.note-hl { color: #1f4aa0; font-weight: 700; }
.fig-hints {
  display: block;
  border: 0;
  font-size: 12px;
  line-height: 1.6;
  color: #9F9F9F;
}
.text-primary { color: #267CE5 !important; }
</style>